
export const setOrganizationStart = () => ({
    type:"SET_ORGANIZATION_START"
})

export const setOrganizationSuccess = payload => ({
    type:"SET_ORGANIZATION_SUCCESS",
    payload
})

export const setOrganizationFail = payload => ({
    type:"SET_ORGANIZATION_FAIL",
    payload
})

export const setOrganizationException = payload => ({
    type:"SET_ORGANIZATION_EXCEPTION",
    payload
})


export const  setOrganizationsAsync = (data) => async dispatch => {
    dispatch(setOrganizationStart())
    try {
        dispatch(setOrganizationSuccess(data))

    }catch (e){
        dispatch(setOrganizationException(e.message))
    }
};

